import { useContentSlot } from '@nextgen-web-framework/all';
import ContentSlotBanner from './types/propTypes';

const ScreenBanner = () => {
  const CoverBannerComp = useContentSlot('E2E', ContentSlotBanner.COVER_BANNER, () => <></>);
  return <CoverBannerComp />;
};
export default ScreenBanner;
